import Containers from './layout/containers/containers.vue'
import Headers from './layout/Header/headers.vue'
import AliCodes from './lib/ali/index.vue'
import { debounce} from './tools/debounce/debounce.js'
import Regulars from './tools/regulars/phone/phone.js'
export {
  Regulars,
  Containers,
  AliCodes,
  Headers,
  debounce
}